import * as amplitude from '@amplitude/analytics-browser';
import { Config } from 'app/config';
import React, { createContext, ReactNode, useContext } from 'react';
import { init } from './amplitude/client';

type AmplitudeType = typeof amplitude;

interface Analytics {
  amplitude: AmplitudeType,
}

const AnalyticsContext = createContext<Analytics | null>(null);

interface AnalyticsProviderProps {
  children: ReactNode,
  config: Config,
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children, config }) => {
  const amplitudeInstance = init(config.REACT_APP_AMPLITUDE_API_KEY);

  return <AnalyticsContext.Provider value={{ amplitude: amplitudeInstance }}>{children}</AnalyticsContext.Provider>;
};

export const useAnalytics = (): Analytics | null => useContext(AnalyticsContext);
